export enum LanguageModel {
    // OpenAI
    textEmbedding3Small = 'openai/text-embedding-3-small',
    gpt5Mini = 'openai/gpt-5-mini',
    gpt5Nano = 'openai/gpt-5-nano',
    gpt51Thinking = 'openai/gpt-5.1-thinking',
    gpt51Instant = 'openai/gpt-5.1-instant',
    gpt52 = 'openai/gpt-5.2',
    gpt52Chat = 'openai/gpt-5.2-chat',
    // Google Gemini
    gemini25Flash = 'google/gemini-2.5-flash',
    gemini25FlashLite = 'google/gemini-2.5-flash-lite',
    gemini25Pro = 'google/gemini-2.5-pro',
    gemini3Flash = 'google/gemini-3-flash',
    gemini3ProPreview = 'google/gemini-3-pro-preview',
    gemini31ProPreview = 'google/gemini-3.1-pro-preview',
    gemini31FlashLitePreview = 'google/gemini-3.1-flash-lite-preview',
    // Anthropic Claude
    claudeHaiku45 = 'anthropic/claude-haiku-4.5',
    claudeSonnet45 = 'anthropic/claude-sonnet-4.5',
    claudeSonnet46 = 'anthropic/claude-sonnet-4.6',
    claudeOpus46 = 'anthropic/claude-opus-4.6',
    // Deepseek
    deepseek32 = 'deepseek/deepseek-v3.2',
    deepseek32Thinking = 'deepseek/deepseek-v3.2-thinking',
}

export const EMBED_MODEL = LanguageModel.textEmbedding3Small

export enum LanguageModelBrand {
    openai = 'openai',
    google = 'google',
    anthropic = 'anthropic',
    deepseek = 'deepseek',
}

/**
 * Supported languages for documents and revised answers
 */
export enum SupportedLanguage {
    it = 'it',
    en = 'en',
    es = 'es',
    fr = 'fr',
    de = 'de',
}

/**
 * Language display names (i18n keys)
 */
export const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
    [SupportedLanguage.it]: 'language.italian',
    [SupportedLanguage.en]: 'language.english',
    [SupportedLanguage.es]: 'language.spanish',
    [SupportedLanguage.fr]: 'language.french',
    [SupportedLanguage.de]: 'language.german',
}

/**
 * Content extraction strategies for URL scraping
 */
export enum ExtractionStrategy {
    /** Use Mozilla Readability for content extraction (fast, free, no API calls) */
    READABILITY = 'readability',
    /** Use AI-based extraction (better for complex layouts, requires API calls) */
    AI = 'ai',
}

/**
 * Browser engine options for URL scraping
 */
export enum BrowserEngine {
    /** Use simple HTTP fetch (fast, lightweight, no JavaScript support) */
    FETCH = 'fetch',
    /** Use Puppeteer with headless Chrome (full browser, JavaScript support) */
    PUPPETEER = 'puppeteer',
}
